import {Platform, useWindowDimensions} from 'react-native';

// Browser windows at least this wide get the desktop layout: sidebar
// navigation, the station list beside the map, and screens in centred
// cards. Phones, tablets and the native apps keep the mobile layout.
export const DESKTOP_MIN_WIDTH = 1024;

export const DESKTOP_SIDEBAR_WIDTH = 248;
export const DESKTOP_PANEL_WIDTH = 400;
export const DESKTOP_CONTENT_MAX_WIDTH = 760;
export const DESKTOP_AUTH_COLUMN_WIDTH = 480;

export const useDesktopLayout = () => {
  const {width} = useWindowDimensions();
  return Platform.OS === 'web' && width >= DESKTOP_MIN_WIDTH;
};

// Width a tab screen actually gets: the window on mobile, the centred card
// on desktop. Use it instead of the window width when sizing screen content.
export const useScreenWidth = () => {
  const {width} = useWindowDimensions();
  if (Platform.OS !== 'web' || width < DESKTOP_MIN_WIDTH) {
    return width;
  }
  // Card is capped at DESKTOP_CONTENT_MAX_WIDTH and has a 1px border.
  return Math.min(width - DESKTOP_SIDEBAR_WIDTH, DESKTOP_CONTENT_MAX_WIDTH) - 2;
};
